import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginCoverOrderHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginCoverOrderTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginCoverOrderTableDsk: React.FC<IMarginCoverOrderTableDskProps> = props => {
	return (
		<div className="mrgn_co_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td Scrip">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Scrip"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.scrip}
							/>
						</span>
					</div>
					<div className="td Segment">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Segment"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.segment}
							/>
						</span>
					</div>
					<div className="td EnterStopLoss right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="EnterStopLoss"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.enterStopLoss}
							/>
						</span>
					</div>
					<div className="td MinimumStopLossMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="MinimumStopLossMargin"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.minimumStopLossMargin}
							/>
						</span>
					</div>
					<div className="td MarginRequirement right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="MarginRequirement"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.marginRequirement}
							/>
						</span>
					</div>
					<div className="td FinalMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="FinalMargin"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.finalMargin}
							/>
						</span>
					</div>
					<div className="td Times right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Times"
								onSort={props.sortProps.onSort}
								colName={marginCoverOrderHeading.times}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td Scrip robotoM">
								<span dangerouslySetInnerHTML={{ __html: row.Scrip }}></span>
							</div>
							<div className="td Segment">{row.Segment}</div>
							<div className="td EnterStopLoss right">{toINR(row.EnterStopLoss)}</div>
							<div className="td MinimumStopLossMargin right">{toINR(row.MinimumStopLossMargin)}</div>
							<div className="td MarginRequirement right">{toINR(row.MarginRequirement)}</div>
							<div className="td FinalMargin right">{toINR(row.FinalMargin)}</div>
							<div className="td Times right">{toINR(row.Times)}</div>
						</li>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginCoverOrderTableDsk;
